<template>
  <div class="new-home-recommend">
    <div>
      <div class="new-home-recommend-content">
        <div class="new-home-recommend-tag">
          <span>热门推荐</span>
          <p>简单易用、精选、一站式区域热门组合推荐</p>
          <a-button @click="$router.push('/solution')"> 立即前往 </a-button>
        </div>
        <div class="new-home-recommend-info">
          <template v-for="(el, index) in consumption">
            <div :key="index" @click="adUrl(el.adHref)" v-if="index < 4">
              <v-img
                :attachment-id="el.adAttmId"
                :default-img="require('@/assets/img/banner7.jpg')"
              />
              <div>
                <p>{{ el.title }} <img src="@/assets/img/2.0/HOT.png" /></p>
                <span>{{ el.description }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="new-home-recommend-iot">
        <div @click="$router.push('/replace')">
          <p>IoT硬件</p>
          <span>细致、精准、智能的国产化适配方案</span>
        </div>
        <div @click="$router.push('/solution')">
          <p>解决方案</p>
          <span>好用、精选、场景化的行业创新解决方案</span>
        </div>
        <div @click="$router.push('/result')">
          <p>应用成果</p>
          <span>各类数智转型的场景案例示范</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdvertiseList } from "@/api/advertise";
import VImg from "@/components/VImg";
export default {
  components: {
    VImg,
  },
  data() {
    return {
      consumption: [
        {
          img: require("@/assets/img/zhbg@2x@2x.png"),
          title: "智慧办公",
          desc: "基于开源鸿蒙智慧办公系统利用开源鸿蒙软硬件技术打通智慧办公系统、办公室…",
        },
        {
          img: require("@/assets/img/yyyl.jpg"),
          title: "影音娱乐",
          desc: "基于开源鸿蒙影音娱乐系统利用开源鸿蒙软硬件技术打通智慧办公系统、办公室…",
        },
        {
          img: require("@/assets/img/lycx.jpg"),
          title: "旅游出行",
          desc: "基于开源鸿蒙智慧办公系统利用开源鸿蒙软硬件技术打通智慧办公系统、办公室…",
        },
        {
          img: require("@/assets/img/znjj.png"),
          title: "智能家居",
          desc: "基于开源鸿蒙智慧办公系统利用开源鸿蒙软硬件技术打通智慧办公系统、办公室…",
        },
        {
          img: require("@/assets/img/ydjk.png"),
          title: "运动健康",
          desc: "基于开源鸿蒙智慧办公系统利用开源鸿蒙软硬件技术打通智慧办公系统、办公室…",
        },
      ],
    };
  },
  mounted() {
    this.loadAdData();
  },
  methods: {
    loadAdData() {
      getAdvertiseList({
        adType: "HOME_CONSUMPTION_SCENE_ICON",
        validStatus: "1",
      }).then((list) => {
        console.log(list);
        this.consumption = list.records;
      });
    },
    adUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes cardFadeImg {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.new-home-recommend {
  > div {
    position: relative;
    z-index: 2;
    width: 1280px;
    margin: -124px auto 0;
    padding-bottom: 64px;
  }
  .new-home-recommend-content {
    display: flex;
    background: #ffffff;
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.08);
    .new-home-recommend-tag {
      width: 320px;
      padding: 24px;
      background: url(../../assets/img/2.0/rmtj.png) no-repeat;
      background-size: 100% 100%;
      > span {
        color: #fff;
        display: block;
        font-size: 20px;
        color: #ffffff;
        line-height: 28px;
        margin-bottom: 16px;
      }
      > p {
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
        margin-bottom: 32px;
      }
      > button {
        border: none;
        color: #ea0b06;
      }
    }
    .new-home-recommend-info {
      flex: 1;
      padding: 16px 24px;
      display: flex;
      flex-wrap: wrap;
      > div {
        width: 440px;
        cursor: pointer;
        padding: 24px;
        display: flex;
        height: 144px;
        margin-right: 24px;
        &:nth-child(2n) {
          margin-right: 0;
        }
        > img {
          display: block;
          width: 96px;
          height: 96px;
          margin-right: 16px;
        }
        > div {
          flex: 1;
          > p {
            height: 22px;
            font-size: 16px;
            line-height: 22px;
            color: #262626;
            margin-bottom: 16px;
            display: flex;
            align-items: flex-end;
            transition: all 0.3s;
          }
          > span {
            display: block;
            font-size: 14px;
            line-height: 20px;
            color: #666666;
            max-height: 60px;
            overflow: hidden;
          }
        }
        &:hover {
          > div {
            > p {
              color: #ea0b06;
            }
          }
        }
      }
    }
  }
  .new-home-recommend-iot {
    display: flex;
    justify-content: space-between;
    margin-top: 72px;
    > div {
      width: 416px;
      padding: 36px 24px;
      background-size: 100% 100%;
      cursor: pointer;
      > p {
        font-size: 18px;
        color: #262626;
        line-height: 24px;
        margin-bottom: 16px;
      }
      > span {
        display: block;
        font-size: 14px;
        color: #262626;
        line-height: 20px;
      }
      &:nth-child(1) {
        background: url(../../assets/img/2.0/IoTyjbg.png) no-repeat;
      }
      &:nth-child(2) {
        background: url(../../assets/img/2.0/jjfabg.png) no-repeat;
      }
      &:nth-child(3) {
        background: url(../../assets/img/2.0/yycgbg.png) no-repeat;
      }
    }
  }
}
</style>
